import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import {MatTableDataSource, MatPaginator } from '@angular/material';
import { StudentsService } from 'src/app/shared/services/students.service';
import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';
import {MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-tempstudent-table',
  templateUrl: './tempstudent-table.component.html',
  styleUrls: ['./tempstudent-table.component.css']
})
export class TempstudentTableComponent implements OnInit {

  displayedColumns: string[] =  ['EnrolmentNo','FirstName','LastName','Gender'];
  post:any;
  public resultdata:any;
  dataSource;
  students:any;
  errorMessage: String;
  progressBar:boolean = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _studentsservice:StudentsService,
     changeDetectorRefs: ChangeDetectorRef,
     private snackBar: MatSnackBar) { }

  ngOnInit() {
    this._studentsservice.refreshNeeded$
    .subscribe(()=>{
      this.getAllStudents();
    })
    this.getAllStudents();
  }

  StudentStageToProduction() {

    this._studentsservice.moveTempStudents(AppSettings.API_ENDPOINT+AppSettings.StudentToProduction)
    .subscribe(result =>{
       this.resultdata=result;
       this.progressBar = false;
          this.openSnackBar(this.resultdata,'');
       if(!result){
        return;
        }
    })
  }
  
  getAllStudents() {
    this._studentsservice.getAllTempStudents(AppSettings.API_ENDPOINT+AppSettings.GetAllTempStudents)
    .subscribe(result =>{
      this.resultdata=result;
      this.progressBar = false;
      if(!result){
        return;
    }



    this.dataSource = new MatTableDataSource(this.resultdata);
    this.dataSource.paginator = this.paginator;
  });
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message,action ,{
      duration: 2000,
      verticalPosition: 'bottom'
    });
    }
}
